// src/components/AboutSection.js
import React from "react";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about-content">
        <div className="paragraph-container">
          <p className="about-paragraph">
            Ubicado en el barrio de Patraix, con conexión directa al sistema de
            metro y pleno acceso a servicios urbanos, racó{" "}
            <span className="bold">patraix</span> se presenta como un proyecto
            residencial de escala cuidada y alto estándar de calidad.
          </p>

          <div className="paragraph-divider"></div>

          <p className="about-paragraph">
            El conjunto se compone de 6 viviendas y 2 áticos, concebidos con
            especial atención a la funcionalidad de las plantas, la eficiencia
            espacial y la calidad de las terminaciones.
          </p>

          <div className="paragraph-divider"></div>

          <p className="about-paragraph">
            La orientación de las viviendas y la incorporación de criterios de
            sostenibilidad permiten un óptimo aprovechamiento de la luz natural
            y un elevado nivel de confort térmico.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
